import Cookies from 'js-cookie'

const tokenKey = 'csim-token'

const imTokenKey = 'csim-im-token'

const usernameKey = 'username';

const userIdKey = 'userId';

// 系统Token
export function getToken() {
    return Cookies.get(tokenKey)
}

export function setToken(token) {
    return Cookies.set(tokenKey, token, {expires: 30})
}

export function removeToken() {
    return Cookies.remove(tokenKey)
}

// IM TOKEN
export function getImToken() {
    return Cookies.get(imTokenKey)
}

export function setImToken(imToken) {
    return Cookies.set(imTokenKey, imToken, {expires: 30})
}

export function removeImToken() {
    return Cookies.remove(imTokenKey)
}

// USER NAME
export function getUsername() {
    return Cookies.get(usernameKey)
}

export function setUsername(username) {
    return Cookies.set(usernameKey, username)
}

export function removeUsername() {
    return Cookies.remove(usernameKey)
}

// USER ID
export function getUserId() {
    return Cookies.get(userIdKey)
}

export function setUserId(userId) {
    return Cookies.set(userIdKey, userId)
}

export function removeUserId() {
    return Cookies.remove(userIdKey)
}